module.exports = __webpack_public_path__ + "static/media/icon-meteo.2979e77e.svg";